

export default {
  head: [
    {
      name: "NHP Home",
      path: "/",
    },
    {
      name: "Drought Home",
      path: "/webgis-drought",
      active: true,
    },
    {
      name: "Objective",
      path: "/webgis-drought/proj-obj",
    },
    {
      name:'Download Products',
      path:'/nhp-data-download',
    },
    //{
    //  name:'Tool',
    //  path:'http://localhost:3000/leaflet/draw-on-map',
      //path:'/https://bhuvan-app1.nrsc.gov.in/flood_animation',
      //float: 'right',
    //  active: true,
    //},
    //     {
    //         name:"Technical Proposal",
    //         path:"/webgis-drought/tech-prop"

    //     },
    //     {
    //         name:"Project Team",
    //         path:"/webgis-drought/proj-team"

    //     },
    //    {
    //     name:"Financial Proposal",
    //     path:"/webgis-drought/fin-prop"

    //    }

    // {

    //     name:"menu 3",
    //     path:"/"
    // },
  ],

  breadCrumbs: [
    {
      name: "menu 1",
      path: "/",
    },
    {
      name: "menu 2",
      path: "/",
    },
    {
      name: "menu 3",
      path: "/",
    },
  ],

  mapSideBar: [
    {
      id: 1,
      name: "Standardized Runoff Index",
      displayname: "Standardized Runoff Index (SRI)",
      icon: "stroopwafel",
      dateRequired: true,
      daily: true,
      dateFormat: "YYYYMMDD",
      dateDisplayFormat: "DD-MM-YYYY",
      sliderDateFormat: "DD MMM YYYY",
      hasDefault: true,
      default: "30 Day Cumulative",
      regex: /[0-9]*/gm,
      collapsed: true,
      active: true,
      children: [
        {
          id: 6,
          name: "Annual Cumulative",
          displayname: "Annual Cumulative",
          icon: "stroopwafel",
          ismap: true,
          default: true,
        },

        {
          id: 1,
          name: "30 Day Cumulative",
          displayname: "30 Day SRI",
          icon: "stroopwafel",
          ismap: true,
        },
        {
          id: 2,
          name: "60 Day Cumulative",
          displayname: "60 Day SRI",
          icon: "stroopwafel",
          ismap: true,
        },
        {
          id: 3,
          name: "90 Day Cumulative",
          displayname: "90 Day SRI",
          icon: "stroopwafel",
          ismap: true,
        },
        {
          id: 4,
          name: "180 Day Cumulative",
          displayname: "180 Day SRI",
          icon: "stroopwafel",
          ismap: true,
        },
        {
          id: 5,
          name: "365 Day Cumulative",
          displayname: "365 Day SRI",
          icon: "stroopwafel",
          ismap: true,
        },
      ],
    },
     
    {
      id: 2,
      name: "Standardized Groundwater Level Index",
      displayname: "Standardized Ground Water Index (SGWI)",
      dateRequired: true,
      icon: "stroopwafel",
      dateFormat: "MMMYYYY",
      regex: /[A-Za-z]*[0-9]*/gm,
      dateDisplayFormat: "MMMM YYYY",
      sliderDateFormat: "MMM YYYY",
      // "ismap":true,
      defaultdate: true,
      active: false,

      //   "default":"Telangana",
      collapsed: false,
      children: [
        {
          id: 1,
          name: "Telangana",
          displayname: "#",
          default: true,
          icon: "stroopwafel",
          ismap: true,
        },
      ],
    },
    
    { 
      id: 3,
      name: "Standardized Reservoir Storage Index",
      displayname: "Standardized Reservoir Storage Index (SRSI)",
      ismap: true,
      defaultdate: true,
      dateRequired: true,
      daily: true,
      dateFormat: "YYYYMMDD",
      dateDisplayFormat: "DD-MM-YYYY",
      sliderDateFormat: "DD MMM YYYY",
      // "hasDefault":true,
      // "default":'reservoir',
      regex: /[0-9]*/gm,
      active: false,

      collapsed: false,
      children: [
      
      {/*
             id: 1,
             name: 'srsi',
             displayname: "#",
             icon:"stroopwafel",
             ismap:true,
       default: true,

      */ },
        {
             id: 1,
             name: 'reservoir',
             displayname: "#",
             default: true,
             icon:"stroopwafel",
             ismap:true,
             default:true,
             daily: true,
          dateFormat: "YYYYMMDD",
          dateDisplayFormat: "DD-MM-YYYY",
          sliderDateFormat: "DD MMM YYYY"

        },
        {/*
         id: 3,
         name: 'Select Date',
         displayname: "#",
         default: true,
         icon:"stroopwafel",
         ismap:true,
         default:true,
         dateRequired: true,
         daily: true,
         dateFormat: "YYYYMMDD",
         dateDisplayFormat: "DD-MM-YYYY",
         sliderDateFormat: "DD MMM YYYY",
      */ },
      ]
  },

   // {
     // id: 3,
     
       //name: 'Standardized Reservoir Storage Index ',
       //displayname: "Standardized Reservoir Storage Index (SRSI)",
       //dateRequired: true,
       //icon:"stroopwafel",
       //dateFormat:'MMMYYYY',
       //regex:/[a-z]*[0-9]*/gm,
       //dateDisplayFormat: "MMMM YYYY",
       //sliderDateFormat: "MMM YYYY",
       //daily: true,
     // hasDefault: true,
      //ismap:true,
     //defaultdate: true,
     //active: false,
      
         // "default":"Telangana",
       // collapsed: false,
       //children: [
       
        //{
          //id: 1,
          //name: "srsi",
          //displayname: "#",
          //icon:"stroopwafel",

          //default: true,
          //ismap: true,
          //dateFormat: "MMMYYYY",
      //regex: /[A-Za-z]*[0-9]*/gm,
      //dateDisplayFormat: "MMMM YYYY",
      //sliderDateFormat: "MMM YYYY",
      // "ismap":true,
      //defaultdate: true,
      //active: false,
       
        //},
      // ]
   //},
       

//YOU COMMENTED TILL LINE 206 -247------THIS IS THE ORIGINALSNIPPET

   //{
    //id: 6,
    //name: 'Standardized Reservoir Storage Index ',
    //displayname: "Standardized Reservoir Storage Index (SRSI)",
   //defaultdate: true,
   //disabled: true,
   //children: [
     //{
       //id: 1,
       //name: "srsi",
       //displayname: "#",
       //icon:"stroopwafel",

       //default: true,
       //ismap: true,
       //dateFormat: "MMMYYYY",
   //regex: /[A-Za-z]*[0-9]*/gm,
   //dateDisplayFormat: "MMMM YYYY",
   //sliderDateFormat: "MMM YYYY",
   // "ismap":true,
   //defaultdate: true,
   //active: false,
    
     //},
     
   //],
  //},
    //{
      //id: 4,
      //name: "Standardized Reservoir Storage Index",
       //displayname: "Standardized Reservoir Storage Index (SRSI)",
       //ismap: true,
       //defaultdate: true,
       //dateRequired: true,
       //daily: true,
      //dateFormat: "YYYYMMDD",
      //dateDisplayFormat: "DD-MM-YYYY",
       //sliderDateFormat: "DD MMM YYYY",
        //"hasDefault":true,
       //"default":'reservoir',
       //regex: /[0-9]*/gm,
       //active: false,

       //collapsed: false,
       //children: [
         //{
           //id: 1,
           //displayname: "#",
           //name: "reservoir",
           //"icon":"stroopwafel",
          //default: true,
          //text: "reservoir",
          //ismap: true,
          //daily: true,
          //dateFormat: "YYYYMMDD",
          //dateDisplayFormat: "DD-MM-YYYY",
         // sliderDateFormat: "DD MMM YYYY",
       //  },
     // ],
    
   // },
   {
    id: 4,
  name: "Standardized Water Spread Index",
   displayname: "Standardized Water Spread Index (SWSI)",
   icon: "stroopwafel",
   dateRequired: true,
   //daily: true,
   defaultdate: true,
   dateFormat: "MMMYYYY",
   dateDisplayFormat: "MMMM YYYY",
   sliderDateFormat: "MMM YYYY",
   regex: /[A-Za-z]*[0-9]*/gm,
   //dateFormat: "YYYYMMDD",
  //dateDisplayFormat: "DD-MM-YYYY",
  //sliderDateFormat: "DD MMM YYYY",
  //hasDefault: true,
   //disabled: true,
   //regex: /[0-9]*/gm,
   collapsed: false,
   active: false, 
   children: [

    {
      id: 1,
      name: "State",
      displayname: "State",
      icon: "stroopwafel",
      ismap: true,
      default: true,
      //dateFormat: "MMMYYYY",
   //dateDisplayFormat: "MMMM YYYY",
   //sliderDateFormat: "MMM YYYY",
   //regex: /[A-Za-z]*[0-9]*/gm,
      //dateFormat: "YYYYMMDD",
      //dateDisplayFormat:"DD-MM-YYYY",
      //sliderDateFormat:"DD MMM YYYY",
      //regex: /[0-9]*/gm,
      ismap:true,
      defaultdate: true,
      active: false,
    },
     {
       id: 2,
       name: "swsi",
       displayname: "#",
       icon:"stroopwafel",
       default: true,
       ismap: true,
       dateFormat: "MMMYYYY",
   dateDisplayFormat: "MMMM YYYY",
   sliderDateFormat: "MMM YYYY",
   regex: /[A-Za-z]*[0-9]*/gm,
       //dateFormat: "YYYYMMDD",
       //dateDisplayFormat:"DD-MM-YYYY",
       //sliderDateFormat:"DD MMM YYYY",
       //regex: /[0-9]*/gm,
   
   ismap:true,
   defaultdate: true,
   active: false,
     },
     {
      id: 3,
      name: "Basin",
      displayname: "Basin",
      icon: "stroopwafel",
      ismap: true,
      default: true,
    },
  
   ]
  },
  {
    id: 5,
  name: "Composite Hydrological Drought Index",
   displayname: "Composite Hydrological Drought Index (CHDI)",
   defaultdate: true,
   dateRequired: true,
   icon:"stroopwafel",
   dateFormat: "MMMYYYY",
      regex: /[A-Za-z]*[0-9]*/gm,
      dateDisplayFormat: "MMMM YYYY",
      sliderDateFormat: "MMM YYYY",
   //daily: true,
   defaultdate: true,
   active: false, 
   //disabled: true,
   collapsed: false,
   children: [
     {
       id: 1,
      name: 'chdi',
      displayname: "#",
      icon:"stroopwafel",
      ismap:true,
      default:true,
     },
     
   ],
  },
   
  ],
};
  /*
      id: 6,
      name: "Upload/Draw a ShapeFile",
      displayname: "Upload/Draw a ShapeFile",
      disabled: true,
      position: "bottomleft",
      defaultdate: true,
      active: true,
      
    */
   // {
    //  id: 4,
    //  name: "User ROI",
    //  displayname: "User ROI",
    //  icon: "stroopwafel",
    //  ismap: true,
     // default: true,
// },


